import ActionGroups from '@ulta/core/components/ActionGroups/ActionGroups';

export default ActionGroups;